import consts from "@/consts"
import {getApiProps} from "@/lib/lib";
import range from "lodash/range";
// import {objectComparison} from "@/lib/lib";
const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

// Built on every call and never cached: the array is also changed in place (splice on delete,
// push on a single update, sort in a getter) and nothing tells a cached map that it has gone stale.
function getTemplateReportsIndexMap(state) {
    return new Map(state.templateReports.map((u, i) => [u.id, i]))
}

export default {
    state: {
        templateReportsLiteLoad: false,
        templateReportsFullLoad: false,
        templateReports: [],
    },
    actions: {
        fetchTemplateReports/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchTemplateReports', args, time: Date.now() / 1000})

                const params = getApiProps('template_reports', args)
                this.$api.templateReports.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchTemplateReports', args, inprogress: false})
                    });
            })
        },
        fetchTemplateReportsAll({dispatch, commit}) {
            new Promise((resolve, reject) => {
                this.$api.init.getTemplateReports()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setTemplateReports', response.data)
                            commit('setTemplateReportsLiteLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchTemplateReportsAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchTemplateReportsAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isTemplateReportsLiteLoad) {
                    return resolve(getters.getTemplateReports.length)
                }
                dispatch('fetchTemplateReports', {lite: true})
                    .then((data) => {
                        commit('updateTemplateReports', data)
                        //commit('setTemplateReportsLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchTemplateReportsAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchTemplateReportsAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchTemplateReportsAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchTemplateReportsChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getTemplateReports.length) {
                        return resolve([])
                    }
                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getTemplateReports.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchTemplateReports', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateTemplateReports', data)
                            })
                            .catch(() => {
                                dispatch('fetchTemplateReports', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setTemplateReportsFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchTemplateReportsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchTemplateReportsChanged', args, inprogress: false})
                })
        },
        fetchTemplateReportsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isTemplateReportsFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchTemplateReportsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchTemplateReports', args)
                .then((data) => {
                    commit('updateTemplateReports', data)
                    return dispatch('fetchTemplateReports', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterTemplateReports', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchTemplateReportsChanged', args, inprogress: false})
                });
        },
        fetchFavoritesTemplateReports({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchFavoritesTemplateReports', args, time: Date.now() / 1000})

                dispatch('fetchTemplateReports', {filter: {favorites: true}})
                    .then((data) => {
                        commit('updateTemplateReports', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesTemplateReports', args, inprogress: false})
                    });
            })
        },
        reloadTemplateReportsAll({commit, dispatch}, args) {
            commit('clearTemplateReports')
            return dispatch('fetchTemplateReportsAllLite', args)
                .then(() => {
                    dispatch('fetchTemplateReportsAllPages', args)
                })
        },

        fetchTemplateReport({commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }
                const params = getApiProps('template_reports', args)
                delete params.id;
                this.$api.templateReports.find(args.id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateTemplateReport', response.data)
                            resolve(true)
                        } else {
                            console.error(response);
                            reject(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(false)
                    });
            });
        },

        saveTemplateReport({dispatch}, templateReport) {
            let fn = (templateReport.id) ? 'updateTemplateReport' : 'createTemplateReport'
            return dispatch(fn, templateReport);
        },
        createTemplateReport({commit, dispatch}, templateReport) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('template_reports')
                this.$api.templateReports.create(templateReport, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateTemplateReport', response.data)
                            dispatch('fetchTemplateReportsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateTemplateReport({commit, dispatch}, templateReport) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('template_reports')
                this.$api.templateReports.update(templateReport.id, templateReport, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateTemplateReport', response.data)
                            dispatch('fetchTemplateReportsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        deleteTemplateReport({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('template_reports')
                this.$api.templateReports.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteTemplateReport', id)
                            else commit('updateTemplateReport', response.data)
                            dispatch('fetchTemplateReportsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        restoreTemplateReport({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('template_reports')
                this.$api.templateReports.restore(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateTemplateReport', response.data)
                            dispatch('fetchTemplateReportsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteTemplateReportPermanently({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('template_reports')
                this.$api.templateReports.deletePermanently(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteTemplateReport', id)
                            dispatch('fetchTemplateReportsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        //sayHello() {}
    },
    mutations: {
        setTemplateReportsLiteLoad(state, LiteLoad) {
            state.templateReportsLiteLoad = state.templateReportsLiteLoad || LiteLoad
        },
        setTemplateReportsFullLoad(state, FullLoad) {
            state.templateReportsFullLoad = state.templateReportsFullLoad || FullLoad
        },

        setTemplateReports(state, nTemplateReports) {
            nTemplateReports = nTemplateReports.map(u => {
                //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return Object.freeze(u)
            })
            nTemplateReports.sort(sortByName)
            state.templateReports = nTemplateReports
        },

        updateTemplateReports(state, nTemplateReports) {
            if (!state.templateReports.length) {
                nTemplateReports = nTemplateReports.map(u => {
                    //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return Object.freeze(u)
                })
                nTemplateReports.sort(sortByName)
                state.templateReports = nTemplateReports
                return true
            }

            // console.log('updateTemplateReports', state.templateReports.length)
            const indexById = getTemplateReportsIndexMap(state)
            nTemplateReports.forEach(function (nTemplateReport) {
                let i = indexById.has(nTemplateReport.id) ? indexById.get(nTemplateReport.id) : -1
                if (i < 0) {
                    indexById.set(nTemplateReport.id, state.templateReports.length)
                    state.templateReports.push(Object.freeze(nTemplateReport))
                } else
                if (!state.templateReportsFullLoad || state.templateReports[i][changedField] != nTemplateReport[changedField]) {
                    // updateObjectByDiff(state.templateReports[i], nTemplateReport)
                    delete nTemplateReport.id
                    state.templateReports[i] = Object.freeze({...state.templateReports[i], ...nTemplateReport})
                }
            })
        },
        filterTemplateReports(state, nTemplateReports) {
            // let Ids = state.templateReports.map(u=> u.id)
            let nIds = new Set(nTemplateReports.map(u => u.id))
            state.templateReports = state.templateReports.filter(u => nIds.has(u.id))
        },
        updateTemplateReport(state, nTemplateReport) {
            let i = state.templateReports.findIndex(u => (u.id == nTemplateReport.id))
            if (i < 0) {
                state.templateReports.push(Object.freeze(nTemplateReport))
            } else
            if (!state.templateReportsFullLoad || state.templateReports[i][changedField] != nTemplateReport[changedField]) {
                // updateObjectByDiff(state.templateReports[i], nTemplateReport)
                let templateReport = {...nTemplateReport} //ToDo fix
                delete templateReport.id
                state.templateReports[i] = Object.freeze({...state.templateReports[i], ...templateReport})
            }
        },
        deleteTemplateReport(state, id) {
            let i = state.templateReports.findIndex(u => (u.id == id))
            if (i != -1) {
                state.templateReports.splice(i, 1)
            }
        },
        clearTemplateReports(state) {
            state.templateReports = []
            state.templateReportsLiteLoad = false
            state.templateReportsFullLoad = false
        },
    },
    getters: {
        isTemplateReportsLiteLoad(state) {
            return state.templateReportsLiteLoad
        },
        isTemplateReportsFullLoad(state) {
            return state.templateReportsFullLoad
        },
        getTemplateReports(state) {
            return state.templateReports
        },
        getTemplateReportsByIds(state) {
            return state.templateReports.reduce((templateReportsByIds, u) => {
                templateReportsByIds[u.id] = u
                return templateReportsByIds
            }, {})
        },
    }
}
